import React from "react";

// A14b — Withdraw confirm for a PENDING commissioned search (Commissioned
// Search, Annex A14b). Distinct from the Close confirm (A4): withdraw is only
// possible WHILE NOBODY HAS ACCEPTED — so there is no commission to end and no
// chat to time out. It simply closes the open invitations and tells the invited
// agents. Same 400px dialog recipe as CloseSearchRequestModal so the two never
// drift; containers grow downward (no fixed height, TRANSLATIONS §3).
const WithdrawSearchRequestModal = ({ onCancel, onConfirm, busy }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(17,24,39,0.45)] p-4">
    <div className="w-full max-w-[400px] bg-white rounded-[14px] shadow-[0_20px_50px_rgba(17,24,39,0.3)] p-6 flex flex-col gap-3">
      <span className="text-[15px] font-bold text-[#111827]">
        Withdraw this invitation?
      </span>
      <span className="text-[13px] text-[#6B7280] leading-[1.6]">
        Nobody has accepted yet, so nothing is running in the network. Every
        invited agent will be told you withdrew. No commission ends and no chat
        is affected — there is none until an agent accepts.
      </span>
      <div className="flex justify-end gap-2 pt-1.5">
        <button
          onClick={onCancel}
          className="px-4 py-[9px] bg-white border border-[#E5E7EB] rounded-lg text-[13px] font-semibold text-[#111827] hover:bg-[#F3F4F6]"
        >
          Keep it open
        </button>
        <button
          onClick={onConfirm}
          disabled={busy}
          className="px-4 py-[9px] bg-[#DC2626] text-white rounded-lg text-[13px] font-semibold hover:bg-[#B91C1C] disabled:opacity-50"
        >
          {busy ? "Withdrawing…" : "Withdraw invitation"}
        </button>
      </div>
    </div>
  </div>
);

export default WithdrawSearchRequestModal;
